import { render, staticRenderFns } from "./SnackAlert.vue?vue&type=template&id=184f3c38"
import script from "./SnackAlert.vue?vue&type=script&lang=js"
export * from "./SnackAlert.vue?vue&type=script&lang=js"
import style0 from "./SnackAlert.vue?vue&type=style&index=0&id=184f3c38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports